module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/acoustic-guitars-d8d16681273ea5bb25faa07cb94c4bd4.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/acoustic-guitars.png
// module id = 7EnI
// module chunks = 9 12